import React, { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import { setPublicModal } from "Store/features/public/publicStateSlice";

import trophyIcon from "Assets/trophy.png";
import shareIcon from "Assets/share.png";
import settingIcon from "Assets/setting.png";

import { MODALS } from "Containers/Pages/Modal";

import "./PublicGameButtonGroup.css"; // Assuming you have some styles for this component

const PublicGameButtonGroup = (props) => {
  const dispatch = useDispatch();
  const postcastUser = useSelector((state) => state.publicUserSlice);
  const handleClickShareIcon = async () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Newsie: News Puzzle",
          text: "Play this game!",
          // text: `I solved today\'s Newsie with a score of ${score}`+ "\n" + `in: ${minutes}:${seconds} with ${incorrectGuesses} incorrect guesses`,
          // url
        })
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch(console.error);
    } else if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText("play this game!");
        console.log("Content copied to clipboard");
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    }
  };

  const handleClickTrophyIcon = useCallback(() => {
    dispatch(setPublicModal(MODALS.WINNER));
  }, [dispatch, setPublicModal]);
  return (
    <div className="icons-container">
      {/* {postcastUser?.username ? (
        <div className="public-game-username-text">{postcastUser.username}</div>
      ) : null} */}
      <img src={settingIcon} />
      <img src={trophyIcon} onClick={handleClickTrophyIcon} />
      <img src={shareIcon} onClick={handleClickShareIcon} />
    </div>
  );
};

export default PublicGameButtonGroup;
